/** @format */

import { CurvedLineCharts } from "@/src/components/CommonCharts/CurvedLineCharts";
import {
  gradient1,
  gradient2,
  gradient3,
  HUD_STATS_PROP_LBL_CLR_MAP,
  HUD_STATS_PROPS,
  linkGradientConfigA23,
  STATS_CORNER_MESSAGE,
  tournamentPerformanceConfig,
  TOURNEY_FINISH_DISTRIBUTION_PROP_LBL_MAP,
} from "@/src/constants/StatsCornerConstants";
import { transformStats } from "../../../../../Common/utils/statsUtil";
import { PotContriStats } from "../../components/PotContriStats";
import { ShowdownDetails } from "../../components/ShowdownDetails";
import { BetDetails } from "../../components/BetDetails";
import PerformanceGrid from "../../components/PerformanceGrid";
import PlayPosition from "../../components/PlayPosition";
import ScoreCard from "../../components/ScoreCard";
import EmptyStats from "../../components/EmptyStats";
import styles from "../../Stats.module.css";
import { StealCheckRaiseSection } from "../../components/StealCheckRaiseSection";
import { TourneyFinishDistribution } from "../../components/TourneyFinishDistribution";
import { PlayerProfitGraph } from "../../components/PlayerProfitGraph";

const gradientArr = [gradient1, gradient2, gradient3];
const hudStatsRadialBarArr = [HUD_STATS_PROPS.VPIP, HUD_STATS_PROPS.PFR];
const hudStatsSegmentedProgressArr = [
  HUD_STATS_PROPS.WTSD,
  HUD_STATS_PROPS.WSD,
];
const hudStatsRadialBarArr2 = [
  HUD_STATS_PROPS.THREE_BET,
  HUD_STATS_PROPS.FOLD_TO_THREE_BET,
  HUD_STATS_PROPS.C_BET,
  HUD_STATS_PROPS.FOLD_TO_C_BET,
];
const hudStatsProgressBarArr = [
  HUD_STATS_PROPS.STEAL,
  HUD_STATS_PROPS.CHECK_RAISE,
];

export default function TournamentStats({ statsData }) {
  const tournamentPerformance = statsData?.tournamentstats || {};
  const displayStats = transformStats(
    tournamentPerformance,
    tournamentPerformanceConfig
  );
  const hudStats = statsData?.hudStats || {};
  const profitGraph = statsData?.profitGraph || {};
  const chartDataConfig = {
    xAxisLabel: profitGraph?.xaxisLabel,
    yAxisLabel: profitGraph?.yaxisLabel,
    yAxisKey: "pnl",
    xAxisKey: "tournamentCount",
  };
  const tourneyFinishDistribution =
    statsData?.tournamentFinishDistribution || {};
  return statsData && Object.keys(statsData).length > 0 ? (
    <div className={styles.tabContent}>
      <PlayerProfitGraph
        profitGraph={profitGraph}
        chartDataConfig={chartDataConfig}
      />

      <div className="border-t-[0.0313rem] border-(--teal-700) rounded-t-xl">
        <div className="text-xs font-normal text-primary pt-2.5 flex justify-center gap-1.5">
          <span>🔥</span>
          <span>{STATS_CORNER_MESSAGE}</span>
        </div>

        {/* VPIP PFR SECTION */}
        <PotContriStats
          hudStatsRadialBarArr={hudStatsRadialBarArr}
          hudStats={hudStats}
          gradientArr={gradientArr}
        />

        {/* WTSD and WSD Section */}
        <ShowdownDetails
          hudStatsSegmentedProgressArr={hudStatsSegmentedProgressArr}
          hudStats={hudStats}
        />

        {/* Fold bet section */}
        <BetDetails
          hudStatsRadialBarArr2={hudStatsRadialBarArr2}
          hudStats={hudStats}
        />

        {/* Steal Check Raise section */}
        <StealCheckRaiseSection
          hudStats={hudStats}
          hudStatsProgressBarArr={hudStatsProgressBarArr}
        />
        {/* Performance Grid */}
        <PerformanceGrid title="Tournaments Performance" items={displayStats} />
      </div>
      <PlayPosition
        title="Play by Position"
        data={statsData?.flopSeenData}
        handPlayed={statsData?.tournamentstats?.handPlayed}
      />
      {/* Tournaments Distribution */}
      <TourneyFinishDistribution
        tourneyFinishDistribution={tourneyFinishDistribution}
      />
      {/* Best Score */}
      <ScoreCard title="Top Scores" data={statsData.bestScore} />

      {/* Latest Scores */}
      <ScoreCard title="Latest Scores" data={statsData.lastTournament} />
    </div>
  ) : (
    <div className="h-full mt-24">
      <EmptyStats redirectTo="/tourneyLobby" />
    </div>
  );
}
